/**
 * Back Office Transactions Page
 * Lists all transactions with date filters (today, yesterday, this week, last week, custom)
 */
import { useOutletContext } from 'react-router-dom';
import TransactionsPageComponent from '@/components/merchant/TransactionsPage';

export default function TransactionsPage() {
  const context = useOutletContext() || {};
  const { 
    token = localStorage.getItem('backoffice_token'), 
    restaurant = null, 
    activeRestaurantId = null 
  } = context;

  return (
    <TransactionsPageComponent 
      merchantToken={token} 
      restaurantId={activeRestaurantId || restaurant?.id}
    />
  );
}
